export default __webpack_public_path__ + "static/media/threeDots.7c5cffa3.svg";